import { AngularSignaturePadModule } from '@almothafar/angular-signature-pad';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { RouterModule } from '@angular/router';
import { YouTubePlayerModule } from '@angular/youtube-player';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { IonContentScrollbarModule } from 'ion-content-scrollbar';
import { EqualWidthHeightDirective } from 'src/app/directives/equal-width-height.directive';
import { InViewDirective } from 'src/app/directives/inView.directive';
import { InternalLinksDirective } from 'src/app/directives/internal-links-directive.directive';
import { CaptionPipe } from 'src/app/pipes/caption.pipe';
import { changeTimezone } from 'src/app/pipes/change-timezone.pipe';
import { CustomCurrencyPipe } from 'src/app/pipes/custom-currency.pipe';
import { DateAddPipe } from 'src/app/pipes/date-add.pipe';
import { FollowControlPipe } from 'src/app/pipes/follow-control.pipe';
import { ImageCenterPipe } from 'src/app/pipes/image-center.pipe';
import { ImgDividerPipe } from 'src/app/pipes/img-divider.pipe';
import { IsOpenPipe } from 'src/app/pipes/is-open.pipe';
import { IscomingPipe } from 'src/app/pipes/iscoming.pipe';
import { overrideTimezone } from 'src/app/pipes/override-timezone.pipe';
import { SafeUrlPipe } from 'src/app/pipes/safe-url.pipe';
import { SearchPipe } from 'src/app/pipes/search.pipe';
import { TagClassesPipe } from 'src/app/pipes/tag-classes.pipe';
import { TotalAmountPipe } from 'src/app/pipes/total-amount.pipe';
import { WorkingHoursPipe } from 'src/app/pipes/working-hours.pipe';
import { SwiperModule } from 'swiper/angular';
import { AboutUsComponent } from './about-us/about-us.component';
import { AiChatComponent } from './ai-chat/ai-chat.component';
import { AlphanumInputsComponent } from './alphanum-inputs/alphanum-inputs.component';
import { CartComponent } from './cart/cart.component';
import { CatalogItemDetailPageComponent } from './catalog-item-detail-page/catalog-item-detail-page.component';
import { CatalogComponent } from './catalog/catalog.component';
import { ChatComponent } from './chat/chat.component';
import { CheckInComponent } from './check-in/check-in.component';
import { ConciergeComponent } from './concierge/concierge.component';
import { CreditCardsComponent } from './credit-cards/credit-cards.component';
import { DetailPageComponent } from './detail-page/detail-page.component';
import { EventCalendarComponent } from './event-calendar/event-calendar.component';
import { ExtraFormsComponent } from './extra-forms/extra-forms.component';
import { FaqComponent } from './faq/faq.component';
import { IframeComponent } from './iframe/iframe.component';
import { LanguagesComponent } from './languages/languages.component';
import { LiveRequestComponent } from './live-request/live-request.component';
import { LocationControlComponent } from './location-control/location-control.component';
import { MapComponent } from './map/map.component';
import { MenuSectionComponent } from './menu-section/menu-section.component';
import { MessagesComponent } from './messages/messages.component';
import { MyAccommodationsComponent } from './my-accommodations/my-accommodations.component';
import { MyProfileComponent } from './my-profile/my-profile.component';
import { NewAccommodationComponent } from './new-accommodation/new-accommodation.component';
import { NewCardComponent } from './new-card/new-card.component';
import { NotificationDetailComponent } from './notification-detail/notification-detail.component';
import { NotificationRequestComponent } from './notification-request/notification-request.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { NumberInputComponent } from './number-input/number-input.component';
import { OrderAlertComponent } from './order-alert/order-alert.component';
import { OrderDetailComponent } from './order-detail/order-detail.component';
import { OrdersComponent } from './orders/orders.component';
import { PaymentFailedComponent } from './payment-failed/payment-failed.component';
import { PaymentSuccessfulComponent } from './payment-successful/payment-successful.component';
import { PreCheckInComponent } from './pre-check-in/pre-check-in.component';
import { ProfileComponent } from './profile/profile.component';
import { BooleanRatingComponent } from './rating-types/boolean-rating/boolean-rating.component';
import { NpsRatingComponent } from './rating-types/nps-rating/nps-rating.component';
import { SelectOptionComponent } from './rating-types/select-option/select-option.component';
import { SmileRatingComponent } from './rating-types/smile-rating/smile-rating.component';
import { StarRatingComponent } from './rating-types/star-rating/star-rating.component';
import { RequestFormComponent } from './request-form/request-form.component';
import { ReservationComponent } from './reservation/reservation.component';
import { RoomReservationComponent } from './room-reservation/room-reservation.component';
import { ScheduleComponent } from './schedule/schedule.component';
import { ScheduledCartComponent } from './scheduled-cart/scheduled-cart.component';
import { SearchComponent } from './search/search.component';
import { ServicesComponent } from './services/services.component';
import { ShceduledCartNoteComponent } from './shceduled-cart-note/shceduled-cart-note.component';
import { NegativeSurveyFeedbackComponent } from './survey-header/negative-survey-feedback/negative-survey-feedback.component';
import { PositiveSurveyFeedbackComponent } from './survey-header/positive-survey-feedback/positive-survey-feedback.component';
import { SurveyDetailComponent } from './survey-header/survey-detail/survey-detail.component';
import { SurveyHeaderComponent } from './survey-header/survey-header.component';
import { SurveyListComponent } from './survey-header/survey-list/survey-list.component';
import { SurveyComponent } from './survey/survey.component';
import { VersionCheckerComponent } from './version-checker/version-checker.component';
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';
import { MenuSectionItemComponent } from './menu-section-item/menu-section-item.component';
import { SpaEntranceComponent } from '../restaurant-booking/components/spa-entrance/spa-entrance.component';
import { QRCodeModule } from 'angularx-qrcode';
import { BonusHistoryComponent } from './bonus-history/bonus-history.component';
import { SanitizeHtmlPipe } from 'src/app/pipes/sanitize-html.pipe';
import { IsBetweenTimesPipe } from 'src/app/pipes/is-between-times.pipe';
@NgModule({
  declarations: [
    CaptionPipe,
    SanitizeHtmlPipe,
    DetailPageComponent,
    EqualWidthHeightDirective,
    InternalLinksDirective,
    MenuSectionComponent,
    ProfileComponent,
    MyProfileComponent,
    CheckInComponent,
    ChatComponent,
    MessagesComponent,
    LiveRequestComponent,
    RequestFormComponent,
    OrderDetailComponent,
    ReservationComponent,
    DateAddPipe,
    CartComponent,
    MyAccommodationsComponent,
    ConciergeComponent,
    RoomReservationComponent,
    ImgDividerPipe,
    IsBetweenTimesPipe,
    ImageCenterPipe,
    ServicesComponent,
    CreditCardsComponent,
    NewCardComponent,
    OrdersComponent,
    TotalAmountPipe,
    NotificationDetailComponent,
    NotificationsComponent,
    WorkingHoursPipe,
    InViewDirective,
    ScheduleComponent,
    SurveyComponent,
    AboutUsComponent,
    SafeUrlPipe,
    CatalogComponent,
    FollowControlPipe,
    ExtraFormsComponent,
    NotificationRequestComponent,
    LocationControlComponent,
    FaqComponent,
    LanguagesComponent,
    EventCalendarComponent,
    TagClassesPipe,
    IsOpenPipe,
    NewAccommodationComponent,
    AiChatComponent,
    MapComponent,
    IscomingPipe,
    BooleanRatingComponent,
    NpsRatingComponent,
    SmileRatingComponent,
    StarRatingComponent,
    NegativeSurveyFeedbackComponent,
    PositiveSurveyFeedbackComponent,
    SurveyHeaderComponent,
    SelectOptionComponent,
    SurveyListComponent,
    SurveyDetailComponent,
    SearchComponent,
    SearchPipe,
    CatalogItemDetailPageComponent,
    PaymentSuccessfulComponent,
    PaymentFailedComponent,
    IframeComponent,
    changeTimezone,
    overrideTimezone,
    CustomCurrencyPipe,
    PreCheckInComponent,
    ScheduledCartComponent,
    ShceduledCartNoteComponent,
    OrderAlertComponent,
    AlphanumInputsComponent,
    NumberInputComponent,
    VersionCheckerComponent,
    MenuSectionItemComponent,
    SpaEntranceComponent,
    BonusHistoryComponent
    
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    RouterModule,
    SwiperModule,
    AngularSignaturePadModule,
    ReactiveFormsModule,
    TranslateModule,
    IonContentScrollbarModule,
    GoogleMapsModule,
    YouTubePlayerModule,
    QRCodeModule,
    LottieModule.forRoot({ player: () => player }),
  ],
  exports: [
    TranslateModule,
    CaptionPipe,
    SanitizeHtmlPipe,
    EqualWidthHeightDirective,
    InternalLinksDirective,
    ImgDividerPipe,
    ImageCenterPipe,
    LanguagesComponent,
    IsBetweenTimesPipe,
    IonContentScrollbarModule,
    SearchComponent,
    NumberInputComponent,
    MenuSectionItemComponent,
    CatalogComponent,
    CustomCurrencyPipe
  ],
  providers: [InAppBrowser],
})
export class SharedModule {}
